import React from 'react';
import PropTypes from 'prop-types';
import ListItem from '@material-ui/core/ListItem';
import Collapse from '@material-ui/core/Collapse';
import InboxListItemStatusPie from './InboxListItemStatusPie';
import InboxListItemPathologistSelector from './InboxListItemPathologistSelector';

const InboxListItemDemoV = (props) => {
  const {
    _case,
    isSelected,
    shouldRenderPatologistSelector,
  } = props;

  const handleClick = (event) => {
    event.stopPropagation();
    if (props.sidebarActionButtonClass === 'sidebar__item-activate') {
      props.handleActivation(_case);
    } else {
      props.handleDelete(_case);
    }
  };

  const firstName = _case.partOneGeneralInformation ? _case.partOneGeneralInformation.firstName : '';
  const lastName = _case.partOneGeneralInformation ? _case.partOneGeneralInformation.lastName : '';
  const {
    handleCaseSelected,
    handleCollapse,
    sidebarActionButtonClass,
    actionButtonTitle,
  } = props;
  return (
    <>
      <ListItem
        button
        selected={isSelected}
        classes={{ root: 'sidebar__item', selected: 'is-selected' }}
        onClick={() => {
          handleCaseSelected(_case);
          if (!shouldRenderPatologistSelector) handleCollapse();
        }}
      >
        <div className="sidebar__item-content">
          {sidebarActionButtonClass ? (
            <InboxListItemStatusPie status={_case.status.workFlowStatusDemo} />
          ) : null}

          <div className="sidebar__item-text-container">
            <div className="sidebar__item-title">
            {lastName}<br/><small><i>{firstName}</i></small>
            </div>
            <div className="sidebar__item-subtitle">
              {_case.status.workFlowStatusDemo}
            </div>
          </div>
          {sidebarActionButtonClass ? (
            <button
              type="button"
              className={sidebarActionButtonClass}
              onClick={handleClick}
              title={actionButtonTitle}
            />
          ) : null}

        </div>
      </ListItem>
      {shouldRenderPatologistSelector && (
        <Collapse in={isSelected} timeout="auto" unmountOnExit>
          <InboxListItemPathologistSelector clickedCase={_case} />
        </Collapse>
      )}
    </>
  );
};

InboxListItemDemoV.propTypes = {
  isSelected: PropTypes.bool.isRequired,
  handleCaseSelected: PropTypes.func.isRequired,
};

export default InboxListItemDemoV;
